<template><div><h1>VUX V2.1.1Rc.13 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[fix] 修复 label 宽度不受控于 Group #1110</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] 取消文字使用灰色</li>
</ul>
<h2><a href="/zh-CN/components/radio.html">Radio</a></h2>
<ul><li>[fix] 修复未响应数据变更的 bug #1115</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 添加 slot=right</li>
</ul>
<h2><a href="/zh-CN/components/step.html">Step</a></h2>
<ul><li>[fix] 修复 import 和 module.exports 混用的问题</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[fix] 修复 调用后没有设置webkitOverflowScrolling为touch</li>
</ul>
<h2><a href="/zh-CN/components/x-header.html">XHeader</a></h2>
<ul><li>[fix] 修复不能设置返回文字为空 #1109 @erguotou520</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.13 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.13-208.vue?008ac0b7